import * as React from "react";
import { IShowMoreItem } from "../../types/IShowMoreItem";

export interface IShowMoreProps {
    options: IShowMoreItem[];
    isReadOnly?: boolean;
    disable?: boolean;
}

const ShowMore: React.FC<IShowMoreProps> = ({
    options,
    isReadOnly,
    disable,
}) => {
    const [showPopUp, setShowPopup] = React.useState(false)

    let componentRefShowMore = React.useRef<HTMLInputElement>(null);

    React.useEffect(() => {
        document.addEventListener('click', onClickOutsideComponent)

        return document.removeEventListener(
            "mousedown",
            onClickOutsideComponent,
            false
        );
    }, [])

    const onClickOutsideComponent = (event: any) => {

        if (componentRefShowMore.current && componentRefShowMore.current.contains(event.target)) {
            return;
        }

        setShowPopup(false)
    };


    const [flipLeft, setFlipLeft] = React.useState(false);

const onClick = () => {
    if (disable) return;

    if (componentRefShowMore.current) {
        const rect = componentRefShowMore.current.getBoundingClientRect();

        const popupWidth = 160;

        setFlipLeft(
            window.innerWidth - rect.left < popupWidth + 30
        );
    }

    setShowPopup(!showPopUp);
};



    const renderActions = () => {
        return options.map((option, index) => (
            <div
                className="popUpItem"
                key={index}
                onClick={() => { option.onClick(); setShowPopup(false) }}
                data-testid={"pop-up-" + index}
            >
                <span className="iconWrap" aria-hidden="true">
                    {option.isIcon != undefined && option.isIcon
                        ? <i className={option.icon} />
                        : <img src={option.icon} alt={option.text} />}
                </span>
                <div className="popUpText">{option.text}</div>
            </div>
        ));
    };

    return (
        <div ref={componentRefShowMore} hidden={isReadOnly}>
            <i className={`icon ms-Icon ms-Icon--MoreVertical inheritPosition ${disable && 'disabledIcon'}`}
                aria-hidden="true"
                onClick={onClick} data-testid={"pop-up-i"} />

            {showPopUp && (
                <div className="showMore">
                    <div
                        className={
                            "popUp " +
                            (flipLeft ? "flipLeft " : "flipRight ") +
                            ((options.length === 1 && options[0]?.text !== "Territory Exclude")
                                ? "singleItemPopUp"
                                : "") + ((options[0]?.text === 'Territory Exclude') ? " centeredSingleItemPop" : '')
                        }
                        data-testid={"pop-up-item"}
                    >
                        {renderActions()}
                    </div>
                </div>)}
        </div>
    );
}

export default ShowMore;